export default __webpack_public_path__ + "static/media/img_muslinTwo_yg.14a379d1.jpg";